import { prependBackendAPIHost } from "../../../../../utils/common/api/api";
import { CALL_API_METHODS } from "../../../../../constants/apis";
import { callApi } from "../../../../../utils/common/api/callApi";
import { log_name } from "../constants/Logs.constants";

interface ILogData {
    data: any;
    metaData: any;
}

export const debugLogs = async ({ data, metaData }: ILogData) => {
    try {
        const log = JSON.stringify({
            data,
            meta_data: {
                ...metaData,
                time: Date.now(),
                log_name,
            },
        });

        const url = prependBackendAPIHost("analytics/log/data");
        await callApi({
            url,
            data: { log_name, log },
            method: CALL_API_METHODS.POST,
            extraOptions: { appendExlyBackendHeaders: true },
        });
    } catch {
        // No Action required in case of api call failure
    }
};
